import { render, staticRenderFns } from "./CriterioSelectCampaigns.vue?vue&type=template&id=da36a7d2"
import script from "./CriterioSelectCampaigns.vue?vue&type=script&lang=js"
export * from "./CriterioSelectCampaigns.vue?vue&type=script&lang=js"
import style0 from "./CriterioSelectCampaigns.vue?vue&type=style&index=0&id=da36a7d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports